/**
 * O aparelho de quem usa — para o menu não prometer atalho que não existe.
 *
 * - Mac (e iPad com teclado) mostra ⌘K; o resto, Ctrl+K.
 * - Tela de toque sem mouse (`pointer: coarse`) não mostra atalho nenhum: no celular não há
 *   teclado físico, e "Atalhos do teclado" seria um item que não serve.
 *
 * Funções puras sobre `navigator`/`matchMedia`, com fallback seguro quando não existem (SSR,
 * teste): sem informação, trata como desktop não-Mac.
 */
export function isApplePlatform(
  nav: Pick<Navigator, 'platform' | 'userAgent'> | undefined = globalThis.navigator,
): boolean {
  if (!nav) return false;
  const p = nav.platform ?? '';
  return /Mac|iPhone|iPad|iPod/i.test(p) || /Mac OS X/i.test(nav.userAgent ?? '');
}

export function isCoarsePointer(
  mm: ((q: string) => { matches: boolean }) | undefined = typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function'
    ? window.matchMedia.bind(window)
    : undefined,
): boolean {
  if (!mm) return false;
  // Coarse E sem nenhum ponteiro fino: notebook com tela de toque ainda tem mouse.
  return mm('(pointer: coarse)').matches && !mm('(any-pointer: fine)').matches;
}

/** O rótulo do atalho da busca no aparelho atual. `null` = não mostrar atalho. */
export function searchShortcutLabel(apple: boolean, coarse: boolean): string | null {
  if (coarse) return null;
  return apple ? '⌘K' : 'Ctrl+K';
}
